import React, { useContext } from 'react'
import View from '../../atoms/View'
import Price from '../Price'
import AuctionSvg from '../../other/svg/AuctionSvg'
import BuyNowSvg from '../../other/svg/BuyNowSvg'
import { ItemContext } from 'src/contexts/itemContext'

const ListPriceColumn = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  if (itemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  const { highest_bet, current_dealer_highest_bet } = itemContext
  const buyNowPrice = itemContext.buy_now_contract?.price ?? 0
  return (
    <View className="flex rounded-l-2 shadow-insetSmall">
      <View className="w-[168px] flex items-center justify-center">
        <Price highestBet={highest_bet} yourHighestBet={current_dealer_highest_bet} buyNowPrice={buyNowPrice} />
      </View>
      <View className="w-[104px] flex items-center justify-center rounded-2 bg-groupBlue shadow-dropSmall">
        {buyNowPrice === 0 && <AuctionSvg className="w-13 h-13  text-white" />}
        {buyNowPrice > 0 && <BuyNowSvg className="w-13 h-13  text-white" />}
      </View>
    </View>
  )
}

export default ListPriceColumn
